import React from 'react'

export default () => (
    <svg fill="currentColor" preserveAspectRatio="xMidYMid meet" width="17" height="17" viewBox="0 0 17 17">
        <g />
        <path d="M3 2.692v11.618l11.618-5.837-11.618-5.781zM4 4.308l8.382 4.17-8.382 4.211v-8.381z" />
    </svg>
)
